export const DropSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
    />
  </svg>
);
export const DropSvgOpen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 4.5l7.5 7.5-7.5 7.5"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      d="M20 15V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18L4 15M8 11L12 15M12 15L16 11M12 15V3"
      stroke="#000000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Fb = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 448 512"
    height="42"
    width="42"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path>
  </svg>
);
export const Twitter = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 448 512"
    height="42"
    width="42"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"></path>
  </svg>
);
export const Pintrest = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    height="24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"></path>
  </svg>
);
export const PlusSvg = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    height="24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 19V5"></path>
    <path d="M5 12H19"></path>
  </svg>
);

export const MinusSvg = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    height="24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 12H5"></path>
  </svg>
);

export const TickSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

export const EmailSVG = () => (
  <svg
    fill="#3b5998"
    viewBox="0 0 448 512"
    height="42"
    width="42"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      d="M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm60 148h232c15.5 0 28 12.5 28 28v104c0 15.5-12.5 28-28 28H108c-15.5 0-28-12.5-28-28V208c0-15.5 12.5-28 28-28zm212.8 28.5L224 270.4 127.2 208.5h193.6zM108.5 233.1l104.7 67c6.5 4.2 15 4.2 21.6 0l104.7-67v82.4H108.5v-82.4z"
      clip-rule="evenodd"
    />
  </svg>
);

export const ExpandIcon = ({ width = 24, height = 24, color = "#666" }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 31.8"
  >
    <polygon
      fill={color}
      points="21.5,0 21.5,2.5 27.8,2.5 19.8,10.5 21.5,12.3 29.5,4.3 29.5,10.4 32,10.4 32,0"
    />
    <polygon
      fill={color}
      points="32,21.4 29.5,21.4 29.5,27.6 21.5,19.6 19.8,21.4 27.7,29.3 21.6,29.3 21.6,31.8 32,31.8"
    />
    <polygon
      fill={color}
      points="10.5,0 10.5,2.5 4.2,2.5 12.2,10.5 10.5,12.3 2.5,4.3 2.5,10.4 0,10.4 0,0"
    />
    <polygon
      fill={color}
      points="0,21.4 2.5,21.4 2.5,27.6 10.5,19.6 12.3,21.4 4.3,29.3 10.4,29.3 10.4,31.8 0,31.8"
    />
  </svg>
);

export const CollapseIcon = ({ width = 24, height = 24, color = "#666" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 31.8"
    width={width}
    height={height}
  >
    <polygon
      fill={color}
      points="30.2,12.3 30.2,9.8 23.9,9.8 32,1.8 30.2,0 22.2,8 22.2,1.8 19.8,1.8 19.8,12.3"
    />
    <polygon
      fill={color}
      points="19.8,30 22.2,30 22.2,23.8 30.3,31.8 32,30.1 24,22.1 30.2,22.1 30.2,19.6 19.8,19.6"
    />
    <polygon
      fill={color}
      points="1.8,12.3 1.8,9.8 8.1,9.8 0,1.8 1.8,0 9.8,8 9.8,1.8 12.2,1.8 12.2,12.3"
    />
    <polygon
      fill={color}
      points="12.3,30 9.8,30 9.8,23.8 1.8,31.8 0,30.1 8,22.1 1.8,22.1 1.8,19.6 12.3,19.6"
    />
  </svg>
);

export const ServiceIcon = ({ width = 22, height = 22, color = "#bebebe" }) => (
  <svg
    className="service-icon"
    data-name="service"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    width={width}
    height={height}
    fill={color}
  >
    <path
      className="cls-1"
      d="M11.91 9.53c-.25 0-.45-.2-.45-.45v-3.5c0-.17.1-.33.25-.4 1.43-.7 1.36-2 1.35-2.01 0-.92-.49-1.46-.9-1.75v1.87c0 .16-.09.32-.23.39l-.99.53c-.14.07-.3.07-.43 0L9.44 3.6a.454.454 0 0 1-.23-.39V1.46c-.84.63-.76 1.62-.75 1.67 0 1.48 1.36 2.13 1.42 2.16.16.07.26.23.26.41v2.06c0 .25-.2.45-.45.45s-.45-.2-.45-.45v-1.8c-.53-.32-1.68-1.2-1.68-2.79C7.48 2.47 7.79.91 9.5.3c.14-.05.29-.03.41.06.12.08.19.22.19.37v2.22l.63.36.54-.29V.69c0-.14.07-.27.18-.36.11-.08.26-.11.39-.07.73.22 2.12 1.1 2.12 2.87 0 .04.1 1.72-1.6 2.71v3.23c0 .25-.2.45-.45.45z"
    />
    <path
      className="cls-1"
      d="M8.82 14.75c-.19 0-1.18-.04-2.13-.83l-.06-.06-.17-.21-1.65.03c-.13 0-.24-.04-.32-.13a.422.422 0 0 1-.13-.32V9.14c0-.25.2-.45.45-.45h1.34c.25-.54.91-1.61 2.26-1.94.03 0 .07-.01.11-.01H9.7c.25 0 .45.2.45.45v1.42h2.69c.49.02 1.17.4 1.17 1.33 0 .02.07 1.28-.83 3.85 0 .03-.02.05-.04.08-.05.09-.53.87-1.26.87H8.83zM7.3 13.26c.75.61 1.5.59 1.54.59h3.03c.15 0 .37-.24.47-.4.81-2.34.76-3.47.76-3.49 0-.41-.23-.45-.3-.46H9.69c-.25 0-.45-.2-.45-.45V7.63h-.68c-1.27.34-1.69 1.62-1.69 1.64-.06.19-.23.31-.43.31h-1.2v3.18l1.42-.03c.15 0 .27.06.36.17l.28.35z"
    />
    <path
      className="cls-1"
      d="M4.8 14.09H1.45c-.25 0-.45-.2-.45-.45V8.76c0-.25.2-.45.45-.45h3.36c.25 0 .45.2.45.45v4.88c0 .25-.2.45-.45.45zm-2.91-.89h2.46V9.22H1.89v3.98z"
    />
  </svg>
);

export const VrmobileIcon = ({ color = "#bebebe" }) => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="white"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 0.833328V2.5H17V5H18.6667V0.833328H14.5ZM17 17.5H14.5V19.1667H18.6667V15H17V17.5ZM2.00001 2.5H4.50001V0.833328H0.333344V5H2.00001V2.5ZM2.00001 15H0.333344V19.1667H4.50001V17.5H2.00001V15ZM15.3333 6.64166L9.50001 3.28333L3.66668 6.64166V13.3583L9.50001 16.7167L15.3333 13.3583V6.64166ZM8.66668 14.3083L5.33334 12.3917V8.53333L8.66668 10.475V14.3083ZM9.50001 9.03333L6.20001 7.10833L9.50001 5.20833L12.8 7.10833L9.50001 9.03333ZM13.6667 12.3917L10.3333 14.3083V10.475L13.6667 8.53333V12.3917Z"
      fill="white"
    ></path>
  </svg>
);
